var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResso(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resso",
    clipPath: "url(#clip0_1489_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66634 0.833984C2.54925 0.833984 0.833008 2.55022 0.833008 4.66732V11.334C0.833008 13.4511 2.54925 15.1673 4.66634 15.1673H11.333C13.4501 15.1673 15.1663 13.4511 15.1663 11.334V4.66732C15.1663 2.55022 13.4501 0.833984 11.333 0.833984H4.66634ZM4.16634 5.53965C4.16634 3.95528 5.89164 2.96023 7.24461 3.80971L10.8813 6.09306C12.1255 6.87425 12.1551 8.69298 10.9385 9.51572L9.42881 10.5365L11.0033 11.5845C11.2332 11.7375 11.2955 12.0478 11.1425 12.2777C10.9895 12.5076 10.6791 12.5699 10.4493 12.4169L8.53354 11.1418L7.30174 11.9747C5.95213 12.8873 4.16634 11.897 4.16634 10.282V9.21172C4.16634 8.28032 5.20407 7.72445 5.97943 8.24052L8.52914 9.93765L10.3783 8.68732C10.9972 8.26885 10.9811 7.33652 10.3495 6.93998L6.71287 4.65662C6.04731 4.23873 5.16634 4.7162 5.16634 5.53965V7.00685C5.16634 7.28298 4.94248 7.50685 4.66634 7.50685C4.3902 7.50685 4.16634 7.28298 4.16634 7.00685V5.53965ZM7.63387 10.5431L5.42535 9.07312C5.31459 8.99939 5.16634 9.07885 5.16634 9.21185V10.2821C5.16634 11.1216 6.07766 11.5954 6.74161 11.1464L7.63387 10.5431Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1489_2056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResso);
export default __webpack_public_path__ + "static/media/resso.76f99f0d17f1cc69c0de49c3a777650f.svg";
export { ForwardRef as ReactComponent };